import { calcBaseConfig } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/baseConfig'
import { linkRowFromPoint } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/pointHalo'
import {
  calcTreeData,
  calcBreadcrumbsConfig,
  createSetRootNodeHandler,
  treeTooltipFormatter
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/treeChartUtils'
import { CHART_HEIGHT } from '@aytm/app/stats/page/question-views/components/lib/constants'

export const calcTreemapOptions = props => {
  const { answer, answerVariants, colorTheme, ignoreRefs, ignorePercents, chartLoad, setRootNode, width, height } =
    props

  const seriesData = calcTreeData(answerVariants, answer, {
    colorTheme,
    ignoreRefs,
    ignorePercents,
    percentDecimals: props.reportPercentDecimals
  })

  const options = calcBaseConfig({
    chart: {
      animation: false,
      backgroundColor: 'transparent',
      borderWidth: 0,
      margin: [5, 30, 10, 30],
      shadow: false,
      width,
      // without it Highcharts draws its own 400
      height: height || CHART_HEIGHT,
      events: chartLoad ? { load: chartLoad } : undefined
    },
    legend: { useHTML: true },
    navigation: { breadcrumbs: calcBreadcrumbsConfig() },
    plotOptions: {
      treemap: {
        allowDrillToNode: true,
        allowPointSelect: true,
        animationLimit: 1000,
        dataLabels: {
          enabled: true,
          shadow: true,
          style: {
            fontFamily: 'Ubuntu, Calibri, Segoe, Helvetica, Arial',
            fontSize: '12px',
            lineHeight: '11px',
            textOverflow: 'ellipsis',
            textOutline: 'none',
            textShadow: '#ffffff 0 0 2px'
          }
        },
        layoutAlgorithm: 'squarified'
      },
      series: {
        shadow: false,
        states: { hover: { brightness: 0.05 }, inactive: { opacity: 1 } },
        turboThreshold: 0,
        // Hovering a node tints its row in the list below, as a column or a slice does. No outline
        // in this direction: the tooltip already names the node, and `states.hover` above marks it.
        point: {
          events: {
            mouseOut() {
              linkRowFromPoint(this.series?.chart, null)
            },
            mouseOver() {
              linkRowFromPoint(this.series?.chart, this.id)
            }
          }
        }
      }
    },
    series: [
      {
        type: 'treemap',
        allowDrillToNode: true,
        allowPointSelect: true,
        animationLimit: 1000,
        data: seriesData,
        dataLabels: { enabled: false },
        keys: ['id', 'parent', 'name', 'value', 'color', 'desc', 'last'],
        levels: [
          {
            level: 1,
            dataLabels: { enabled: true },
            borderWidth: 3,
            levelIsConstant: false
          },
          {
            level: 2,
            dataLabels: { style: { fontSize: '10px' } }
          }
        ],
        name: 'All',
        events: setRootNode ? { setRootNode: createSetRootNodeHandler(setRootNode) } : undefined
      }
    ],
    tooltip: { formatter: treeTooltipFormatter }
  })

  return { options }
}
